import { getSelectedCategoryName } from '../helpers/get-selected-category-name.js';

function initializePerformanceLength() {
	const categoryName = getSelectedCategoryName(this.formElement);

	const labelElement = this.currentStepElement.querySelector('label[for="quote-request-performance-length"]');
	if (categoryName) {
		labelElement.dataset.originalText = labelElement.textContent;
		labelElement.textContent = `How long will your ${categoryName} be needed?`;
	} else if (labelElement.dataset.originalText) {
		labelElement.textContent = labelElement.dataset.originalText;
	}
}

export {
	initializePerformanceLength
}